module.exports = __webpack_public_path__ + "images/renessans-0f5b8c8e.png";